import PromotionListingPage from './promotion-list';

interface IBXGYPromo {}

const BXGYPromo: React.FunctionComponent<IBXGYPromo> = props => {
  return <PromotionListingPage promo={'BXGY'} promoName="BXGY Discount"/>
};

export default BXGYPromo;
